// overlay.js
// 功能：动态创建遮罩层，渐显/渐隐，支持嵌套
// 可选点击自动关闭，可选阻止滚动锁定页面
// 用法：
// import Overlay from './overlay.js'
// const overlay = Overlay.create({
//   opacity: 0.5,
//   duration: 300,
//   clickToClose: true,
//   lockScroll: true,
//   onClick: () => console.log('遮罩被点击')
// })
// overlay.show()
// overlay.hide()

const Overlay = (() => {
  let instance = null;
  let lockCount = 0; // 遮罩层嵌套计数
  let scrollLockCount = 0; // 阻止滚动事件计数

  function preventScroll(e) {
    e.preventDefault();
  }

  function lockBodyScroll() {
    scrollLockCount++;
    if (scrollLockCount > 1) return;
    document.addEventListener('wheel', preventScroll, { passive: false });
    document.addEventListener('touchmove', preventScroll, { passive: false });
  }

  function unlockBodyScroll() {
    if (scrollLockCount === 0) return;
    scrollLockCount--;
    if (scrollLockCount > 0) return;
    document.removeEventListener('wheel', preventScroll);
    document.removeEventListener('touchmove', preventScroll);
  }

  class OverlayClass {
    constructor({ opacity = 0.5, duration = 300, clickToClose = false, lockScroll = false, onClick } = {}) {
      this.opacity = opacity;
      this.duration = duration;
      this.clickToClose = clickToClose;
      this.lockScroll = lockScroll;
      this.onClick = onClick;
      this.el = null;
    }

    _create() {
      if (this.el) return;

      const overlay = document.createElement('div');
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.background = `rgba(0,0,0,${this.opacity})`;
      overlay.style.opacity = '0';
      overlay.style.transition = `opacity ${this.duration}ms ease`;
      overlay.style.zIndex = 9998;

      if (this.clickToClose) {
        overlay.addEventListener('click', () => {
          this.hide();
          if (typeof this.onClick === 'function') {
            this.onClick();
          }
        });
      }

      document.body.appendChild(overlay);
      this.el = overlay;
    }

    show() {
      lockCount++;
      this._create();
      this.el.style.display = 'block';
      void this.el.offsetWidth; // 强制浏览器渲染初始状态
      this.el.style.opacity = `${this.opacity}`;

      if (this.lockScroll) lockBodyScroll();
    }

    hide() {
      if (lockCount === 0) return;
      lockCount--;
      if (lockCount > 0) return;

      if (!this.el) return;

      this.el.style.opacity = '0';
      this.el.addEventListener('transitionend', () => {
        if (this.el) {
          this.el.style.display = 'none';
          this.el.remove();
          this.el = null;
        }
      }, { once: true });

      if (this.lockScroll) unlockBodyScroll();
    }
  }

  return {
    create(options) {
      if (!instance) {
        instance = new OverlayClass(options);
      }
      return instance;
    }
  };
})();

export default Overlay;
